import apiClient from "../Config/Index";
import ShowNotifications from "../helper/ShowNotifications";

class ContactApi {
    async getContactList(params) {
        try {
            const response = await apiClient.get(`/contact/list`, { params });
            if (response.status === 200 || response.status === 201) {
                return { status: true, response: response.data };
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || "Failed to get contact messages.";
            ShowNotifications.showAlertNotification(errorMessage, false);
            return { status: false, response: error?.response?.data || error };
        }
    }

    async deleteContact(id) {
        try {
            const response = await apiClient.delete(`/contact/delete/${id}`);
            if (response.status === 200 || response.status === 201) {
                ShowNotifications.showAlertNotification(response.data.message || "Message deleted successfully!", true);
                return { status: true, response: response.data };
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || "Failed to delete message.";
            ShowNotifications.showAlertNotification(errorMessage, false);
            return { status: false, response: error?.response?.data || error };
        }
    }
}

export default new ContactApi();
